export default "__VITE_ASSET__CllHwSZ4__"